"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConversationListItemDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const User_dto_1 = require("../users/User.dto");
const Venue_dto_1 = require("../Venue.dto");
class ConversationListItemDto {
  constructor() {
    this.unreadCount = 0;
    this.duration = 0;
  }
}
exports.ConversationListItemDto = ConversationListItemDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], ConversationListItemDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: () => User_dto_1.UserDto
}), __metadata("design:type", User_dto_1.UserDto)], ConversationListItemDto.prototype, "fromUser", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: () => User_dto_1.UserDto
}), __metadata("design:type", User_dto_1.UserDto)], ConversationListItemDto.prototype, "toUser", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: () => User_dto_1.UserDto
}), __metadata("design:type", User_dto_1.UserDto)], ConversationListItemDto.prototype, "otherUser", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Venue_dto_1.VenueDto
// only the last message, but to make it compatible with previous mobile versions, we can use it like this
)], ConversationListItemDto.prototype, "venueConnectedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Array)], ConversationListItemDto.prototype, "messages", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], ConversationListItemDto.prototype, "unreadCount", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], ConversationListItemDto.prototype, "duration", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], ConversationListItemDto.prototype, "createdAt", void 0);
//# sourceMappingURL=ConversationListItem.dto.js.map